import { useQuery } from '@tanstack/react-query';
import { getDoubleCoderScores } from './requests';

export function useGetDoubleCoderScores(videoUploadId: number) {
  return useQuery({
    queryKey: [
      'video-obs',
      'video-uploads',
      videoUploadId,
      'double-coder-scores'
    ],
    queryFn: () => getDoubleCoderScores(videoUploadId).then(res => res.data),
    refetchOnWindowFocus: false
  });
}
